import styled from 'styled-components';

export const FeedbackFileUploadPrompt = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  width: 294px;
`;

export const FeedbackFileUploadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`;
